import * as constAction from 'root/actionConstants';

export const clear = value => ({
  type: constAction.VEHICULOS_CLEAR,
  payload: value,
});

export const setState = values => ({
  type: constAction.VEHICULOS_SET_STATE,
  payload: values,
});

export const get = () => ({
  type: constAction.VEHICULOS_GET,
  payload: {
    filter: {
      order: 'nombre ASC',
      include: ['_codigo', '_dispositivo', '_chofer'],
    },
  },
  epic: {
    url: 'vehiculos',
    method: 'GET',
  },
});

export const actualizarState = result => ({
  type: constAction.VEHICULOS_LISTA_SET,
  payload: result,
});

export const getById = id => ({
  type: constAction.VEHICULOS_GET_BY_ID,
  payload: {
    filter: {
      include: ['_chofer', '_dispositivo', '_codigo'],
    },
  },
  epic: {
    url: 'vehiculos/' + id,
    method: 'GET',
  },
});

export const set = (data, id) => ({
  type: constAction.VEHICULOS_SET,
  payload: {
    ...data,
  },
  epic: {
    url: id != 'new' ? 'vehiculos/' + id : 'vehiculos/crear',
    method: id != 'new' ? 'PATCH' : 'POST',
  },
});

export const delete_ = id => ({
  type: constAction.VEHICULOS_DELETE,
  state: {
    id,
  },
  epic: {
    url: 'vehiculos/' + id,
    method: 'DELETE',
  },
});

export const seleccionarChofer = query => ({
  type: constAction.VEHICULOS_SELECCIONAR_CHOFER,
  payload: {
    rol: 'chofer',
    query,
  },
  epic: {
    url: 'usuarios/buscarPorRol',
    method: 'POST',
  },
});

export const seleccionChofer = chofer => ({
  type: constAction.VEHICULOS_SET_CHOFER,
  payload: chofer,
});

export const seleccionarDispositivo = query => ({
  type: constAction.VEHICULOS_SELECCIONAR_DISPOSITIVO,
  payload: {
    query,
  },
  epic: {
    url: 'dispositivos/buscar',
    method: 'GET',
  },
});

export const seleccionDispositivo = dispositivo => ({
  type: constAction.VEHICULOS_SET_DISPOSITIVO,
  payload: dispositivo,
});



// WEBPACK FOOTER //
// src/modules/vehiculos/action.js